import { Dialog, ErrorStatusBanner } from '@gov-nx/ui/web';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { is } from '@gov-nx/core/types';
import { AuthorizationSkeleton } from './Skeleton';
import { AuthorizationMethods } from './AuthorizationMethods';
import { AuthorizationType } from '../types';
import { useAutorizaceContext } from '../Context';

export const AuthorizationDialog = () => {
	const authContext = useAutorizaceContext();
	const { t } = useLocale(authContext?.code ?? '');

	if (!is(authContext)) {
		return;
	}

	const loading = authContext.startAuthorization.isLoading;
	const isError = authContext.startAuthorization.isError;

	const allowedAuthorizationTypes =
		authContext.startAuthorization.data?.data.metodyAutorizace?.map(
			(method) => AuthorizationType[method]
		) ?? [];

	return (
		<Dialog
			isOpen
			blockClose={authContext.confirmAuthCode.isLoading}
			title={<h3>{t('dialog.title')}</h3>}
			onClose={authContext.onDialogCloseClick}>
			<p className="mb-(--spacing-l)! text-body-xl!">
				{t('dialog.description')}
			</p>
			{loading && <AuthorizationSkeleton />}
			{!loading && isError && (
				<ErrorStatusBanner code={LocalizeNameSpaceTypes.Global} />
			)}
			{!loading && !isError && (
				<AuthorizationMethods
					code={authContext.code}
					allowedAuthorizationTypes={allowedAuthorizationTypes}
				/>
			)}
		</Dialog>
	);
};
